// @flow
import React from 'react'

export const VersionComponent = (props: {style: Object}): React.Element<any> => (
  <div style={props.style}>
    <span>
      v-0.8.0
    </span>
  </div>
)

export default VersionComponent
